import React from 'react';
import { ReactComponent as Small_Arrow } from "../../../../assets/utils/images/svgs/Small_Arrow.svg";
import { ReactComponent as Save } from "../../../../assets/utils/images/svgs/save_two.svg";
import { Button, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    message: Yup.string()
        .required("Geef een omschrijving mee voor reden afkeur. (min. 4 karakters)")
        .min(4, "Geef een omschrijving mee voor reden afkeur. (min. 4 karakters)"),
});

const RejectOrDeleteModal = ({ setOpenRejectOrDeleteModal, openRejectORDeleteModal, handleUpdateStatus }) => {
    const [reason, setReason] = React.useState('');
    return (
        <Modal id={"tooltip"} isOpen={openRejectORDeleteModal} toggle={() => setOpenRejectOrDeleteModal(!openRejectORDeleteModal)} className="rejectOrDeleteModal modal-centered feedback-modal-style opmerking-modal-styling">
            <ModalHeader>
                <div className="modal-header-styling">
                    {
                        openRejectORDeleteModal?.value === 'reject' ? 'Reden van afkeuren' : 'Verwijderen'
                    }
                </div>
                <button type="button" class="btn-close" aria-label="Close" onClick={() => setOpenRejectOrDeleteModal(false)}></button>
            </ModalHeader>

            <ModalBody className='d-flex bg-white rounded px-0'>
                {
                    <Formik
                        enableReinitialize
                        validationSchema={openRejectORDeleteModal?.value === 'reject' ? validationSchema : undefined}
                        initialValues={{ message: reason || '' }}
                        onSubmit={(values, { setSubmitting }) => openRejectORDeleteModal?.value === 'reject' ? handleUpdateStatus('rejected', values.message, setSubmitting) : handleUpdateStatus('deleted', null, setSubmitting)}
                    >
                        {({
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            values
                        }) => (
                            <Form onSubmit={handleSubmit} className='w-100'>
                                {openRejectORDeleteModal?.value === 'reject' ?
                                    <>
                                        <Input
                                            type="textarea"
                                            className="form-style opmerking-input-styling my-3 m-auto"
                                            name='message'
                                            onChange={(e) => {
                                                setReason(e.target.value || "")
                                            }}
                                            onBlur={handleBlur}
                                            value={values.message}
                                            rows="6"
                                        />
                                        <ErrorMessage name="message" component="small"
                                            className="ms-4 block mt-2 mb-2 invalid-feedback" /></> : <p className='warning-text py-4'>Wil je dit document echt verwijderen?</p>
                                }
                                <ModalFooter className='border-bottom-0'>
                                    <Button className="d-flex align-items-center btn-color-style opslaan-btn" size="sm" outline color="primary" type='submit' disabled={isSubmitting} >
                                        {
                                            openRejectORDeleteModal?.value === 'reject' ?
                                                <>
                                                    <Save />
                                                    Opslaan
                                                </> : <>Ja</>
                                        }
                                    </Button>
                                    <Button className="d-flex align-items-center btn-color-style opslaan-btn" size="sm" outline color="primary" onClick={() => setOpenRejectOrDeleteModal(false)}>
                                        {
                                            openRejectORDeleteModal?.value === 'reject' ?
                                                <>
                                                    <Small_Arrow />
                                                    Terug
                                                </> :
                                                <>Nee</>
                                        }
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                }
            </ModalBody>
        </Modal>
    )
}

export default RejectOrDeleteModal;
